
import { useState } from 'react';

export default function Footer() {
  const [formData, setFormData] = useState({
    email: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', formData.email);

      const response = await fetch('https://readdy.ai/api/form/d61as43n6d2i4h4oa6pg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ email: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer id="contact-form" className="bg-zinc-900 rounded-t-[32px] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-4">
            <h3 className="text-2xl font-bold text-white mb-2">
              McCrea's
            </h3>
            <p className="text-emerald-400 text-sm font-medium mb-4">Landscaping & Irrigation</p>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Transforming outdoor spaces with professional landscaping and irrigation services since 2009
            </p>
            <a
              href="tel:3347826042"
              className="flex items-center space-x-2 text-emerald-400 hover:text-emerald-300 transition-colors text-base font-semibold cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>(334) 782-6042</span>
            </a>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  About
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-white font-semibold mb-4">Connect With Us</h4>
            <a 
              href="https://www.facebook.com/profile.php?id=100063492195868" 
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer"
            >
              <i className="ri-facebook-line text-xl"></i>
              <span>Follow us on Facebook</span>
            </a>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-white font-semibold mb-4">Stay Updated</h4>
            <p className="text-gray-400 text-sm mb-4">Get landscaping tips & seasonal offers</p>
            <form onSubmit={handleSubmit} data-readdy-form className="relative">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={(e) => setFormData({ email: e.target.value })}
                placeholder="Your email"
                required
                className="w-full px-4 py-3 bg-zinc-800 border border-zinc-700 rounded-full text-white text-sm focus:outline-none focus:border-emerald-600 pr-12"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="absolute right-1 top-1 w-10 h-10 flex items-center justify-center bg-white rounded-full hover:bg-emerald-600 transition-colors cursor-pointer disabled:opacity-50"
              >
                <i className="ri-arrow-right-line text-gray-900"></i>
              </button>
            </form>
            {submitStatus === 'success' && (
              <p className="text-emerald-400 text-sm mt-2">Thank you for subscribing!</p>
            )}
            {submitStatus === 'error' && (
              <p className="text-red-400 text-sm mt-2">Something went wrong. Please try again.</p>
            )}
          </div>
        </div>

        <div className="relative mb-8">
          <div className="text-[120px] font-bold text-zinc-800 text-center leading-none select-none">
            MCCREA'S
          </div>
        </div>

        <div className="text-center text-gray-500 text-sm border-t border-zinc-800 pt-8">
          <p>© 2025 McCrea's Landscaping & Irrigation. All rights reserved. | Privacy Policy | Terms of Service</p>
          <p className="mt-2">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400 transition-colors">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
